if (!customElements.get('option-value')) {
  class OptionValue extends HTMLElement {
    constructor() {
      super();
      this.handleChange = this.#handlePickerChange.bind(this);
      this.handleVariantUpdate = this.#handleVariantUpdate.bind(this);
    }

    connectedCallback() {
      this.#syncFromSelection();
      this.#bindPickerEvents();
      requestAnimationFrame(() => this.#syncFromSelection());
    }

    disconnectedCallback() {
      this.#unbindPickerEvents();
    }

    #picker() {
      return this.closest('variant-picker');
    }

    #inputName() {
      return this.getAttribute('data-input-name') || '';
    }

    #getInputs() {
      const picker = this.#picker();
      const name = this.#inputName();
      if (!picker || !name) return [];
      return Array.from(picker.querySelectorAll(`input[type="radio"][name="${CSS.escape(name)}"]`));
    }

    #bindPickerEvents() {
      this.picker = this.#picker();
      if (!this.picker) return;
      this.picker.addEventListener('change', this.handleChange);
      this.picker.addEventListener('variant:update', this.handleVariantUpdate);
    }

    #unbindPickerEvents() {
      if (!this.picker) return;
      this.picker.removeEventListener('change', this.handleChange);
      this.picker.removeEventListener('variant:update', this.handleVariantUpdate);
      this.picker = null;
    }

    #findChecked() {
      const inputs = this.#getInputs();
      const checkedInput = inputs.find((input) => input.checked);
      if (checkedInput) return checkedInput;

      return inputs.find((input) => input.dataset.currentChecked === 'true') || null;
    }

    #handlePickerChange(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (target.name !== this.#inputName()) return;
      this.update({ target });
    }

    #handleVariantUpdate() {
      this.#syncFromSelection();
      requestAnimationFrame(() => this.#syncFromSelection());
    }

    #syncFromSelection() {
      const checked = this.#findChecked();
      if (!checked) return;
      this.update({ target: checked });
    }

    /**
     * @param {{ target: HTMLInputElement }} event
     */
    update(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;

      const subgroup = this.getAttribute('subgroup');
      const targetSubgroup = target.getAttribute('data-subgroup') || '';

      const shouldShow = subgroup
        ? subgroup === targetSubgroup
        : targetSubgroup === '';

      this.textContent = shouldShow ? target.value : '';
    }
  }

  customElements.define('option-value', OptionValue);
}
